import { RootState } from 'app/store';
import { pronoGamesAdapter } from './prono.adapter';

export const {
  selectAll: selectPronoGames,
  selectById: selectPronoGameById,
  selectTotal: selectPronoGamesTotal,
} = pronoGamesAdapter.getSelectors(({ prono }: RootState) => prono.list);

export const pronoListSelector = ({ prono }: RootState) => prono.list;

export const currentPronoSelector = ({ prono }: RootState) => prono.current;

export const isFormValidSelector = ({ prono }: RootState) => prono.current.isStepValid;

export const selectedPronoSelector = ({ prono }: RootState) => prono.selected;
